'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.invert = invert;
exports.isObject = isObject;
exports.mergeDeep = mergeDeep;
exports.makeDeepTree = makeDeepTree;
exports.isEmpty = isEmpty;
exports.deepValueByPath = deepValueByPath;
exports.deepUpdateByPath = deepUpdateByPath;
exports.getAPIUrl = getAPIUrl;
exports.combineListsSingleType = combineListsSingleType;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function invert(object) {
    var result = {};

    function setValue(target, path, value) {
        var last = path.pop();
        path.reduce(function (o, k) {
            return o[k] = o[k] || {};
        }, target)[last] = value;
    }

    function iter(o, p) {
        if (o && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object') {
            Object.keys(o).forEach(function (k) {
                return iter(o[k], [].concat(_toConsumableArray(p), [k]));
            });
            return;
        }
        p.unshift(p.pop());
        setValue(result, p, o);
    }

    iter(object, []);
    return result;
};

function isObject(item) {
    return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item) && item !== null;
}

function mergeDeep(target, source) {
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(function (key) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, _defineProperty({}, key, {}));
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, _defineProperty({}, key, source[key]));
            }
        });
    }
    return target;
}

function makeDeepTree(path, data) {
    var ret = {};
    var obj = ret;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = path.split(".")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var subpath = _step.value;
            obj = obj[subpath] = {};
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    Object.entries(data).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        return obj[k] = v;
    });
    return ret;
}

function isEmpty(obj) {
    return Object.keys(obj).length == 0;
}

function deepValueByPath(obj, path) {
    for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
        if (!obj.hasOwnProperty(path[i])) {
            return "";
        }
        obj = obj[path[i]];
    }
    return obj;
};

function deepUpdateByPath(path, upd) {
    var obj = {};
    var nobj = obj;
    for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
        if (i + 1 == len) {
            nobj[path[i]] = upd;
        } else {
            nobj[path[i]] = {};
        }
        nobj = nobj[path[i]];
    }
    return obj;
}

function getAPIUrl(urls, options) {
    var matchedUrls = [];
    var finalUrl = null;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = urls[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var url = _step2.value;

            var matching = true;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = url.parameters[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var param = _step4.value;

                    if (options == undefined) {
                        matching = false;break;
                    }
                    if (!options.hasOwnProperty(param)) {
                        matching = false;break;
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            if (matching) matchedUrls.push(url);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = matchedUrls[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _url = _step3.value;

            if (finalUrl == null) {
                finalUrl = _url;continue;
            }
            if (finalUrl.parameters.length < _url.parameters.length) {
                finalUrl = _url;continue;
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    var ret = eval('`' + finalUrl.url + '`');
    return ret;
}

function combineListsSingleType() {
    var ret = [];
    var intermediate = {};
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
        for (var _iterator5 = arguments[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var l = _step5.value;
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = l[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var elem = _step6.value;

                    intermediate[elem.constructor.name] = elem;
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
            }
        } finally {
            if (_didIteratorError5) {
                throw _iteratorError5;
            }
        }
    }

    Object.values(intermediate).map(function (e) {
        ret.push(e);
    });
    return ret;
}

var action_once = exports.action_once = function action_once(condition, action) {
    return function (dispatch, getState) {
        return new Promise(function (resolve, reject) {
            var state = getState();
            if (condition(state)) {
                dispatch(action).then(function () {
                    return resolve();
                });
            } else {
                resolve();
            }
        });
    };
};